import { render, staticRenderFns } from "./UserDataProfileList.vue?vue&type=template&id=719d8788&"
import script from "./UserDataProfileList.vue?vue&type=script&lang=js&"
export * from "./UserDataProfileList.vue?vue&type=script&lang=js&"
import style0 from "./UserDataProfileList.vue?vue&type=style&index=0&id=719d8788&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports